import {
  COMMUNICATION_CHANNEL_CONSENT_RESPONSE_DESER,
  CommunicationChannelConsent,
  CommunicationChannelConsentUpdate,
} from "../../tastyworks/communication-channel-consents"
import HttpClient from "../../tastyworks/http"
import { recursiveDasherizeKeys } from "../../tastyworks/request"
import { updateSingleResponse } from "../../tastyworks/response"
import { JsonHelper } from "../../tastyworks/util/json"

function parseConsentResponse(helper: JsonHelper) {
  const target = new CommunicationChannelConsent()
  return updateSingleResponse(
    helper,
    target,
    COMMUNICATION_CHANNEL_CONSENT_RESPONSE_DESER.update
  )
}

export class CommunicationChannelConsentsService {
  private readonly customerMeClient: HttpClient

  constructor(customerMeClient: HttpClient) {
    this.customerMeClient = customerMeClient.nested(
      "communication-channel-consents"
    )
  }

  async search(mobilePhoneNumber?: string) {
    return this.customerMeClient
      .postJson("search", {
        "mobile-phone-number": mobilePhoneNumber,
      })
      .then(parseConsentResponse)
  }

  async update(consent: CommunicationChannelConsentUpdate) {
    return this.customerMeClient
      .put("", recursiveDasherizeKeys(consent))
      .then(parseConsentResponse)
  }
}
